import React from "react";
import { classNames } from "@root/_utils";

type CountrySelectProps = {
  value: string;
  name: string;
  selectRef: React.RefObject<HTMLSelectElement>;
  optionsString: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  error?: {
    error: boolean;
    message: string;
  };
};

const CountrySelect = ({
  value,
  name,
  selectRef,
  optionsString,
  onChange,
  label,
  error,
}: CountrySelectProps): React.JSX.Element => {

  const hasError = error && error.error === true;

  const selectClassNames = classNames(
    "gc__input_field",
    { "gc__input_field_error": hasError },
  );

  const labelMarkup = (label) ? <label className={"gc__input_label"}>{label}</label> : null;

  const errorMarkup = (hasError) ? <p className={"gc__input_field_error_message"}>{error.message}</p> : null;

  // const filteredOptions = useMemo(() => {
  //   if (optionsString.includes("TEST COUNTRY")) {
  //     return optionsString; // We are in Shopify Admin
  //   }

  //   const options = optionsString.split("\n");
  //   return options.find((option) => option.includes('\"United States\"'));
  // }, [optionsString]);

  return (
    <>
      <div className={"gc__input_container"}>
        {labelMarkup}
        <select
          ref={selectRef}
          className={selectClassNames}
          name={name}
          value={value}
          onChange={e => onChange(e)}
          dangerouslySetInnerHTML={{ __html: optionsString }}
        />
      </div>
      {errorMarkup}
    </>
  );
};

export default CountrySelect;
